var A = /* @__PURE__ */ ((r) => (r.VARIANT_A = "hero--variant-a", r.VARIANT_B = "hero--variant-b", r))(A || {});
export {
  A as RocheUIHeroVariant
};
